import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconQm3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconQm3"><Path fillRule="evenodd" clipRule="evenodd" d="M8.74989 2.68933L13.3105 7.24999L12.2499 8.31065L9.49989 5.56065V14H20.9999V15.5H9.08167L3.80034 21.3095L2.69043 20.3004L7.99989 14.46V5.56065L5.24989 8.31065L4.18923 7.24999L8.74989 2.68933Z" fill="currentColor"/></CentralIconBase>;
});

export default IconQm3;
